<template>
    <div class="memberManangementPage">
        <headerNotice routerName="成员管理"></headerNotice>
        <!-- 筛选条 -->
        <div class="searchBox">
            <h2 class="searchTitle">
                <i></i>
                <span>筛选查询</span>
            </h2>
            <el-form :inline="true" :model="searchForm" class="demo-form-inline searchForm">
                <el-form-item label="输入搜索">
                    <el-input v-model="searchForm.Keyword" clearable placeholder="成员账号"></el-input>
                </el-form-item>
                <el-form-item label="启用状态">
                    <el-select v-model="searchForm.status" placeholder="全部">
                        <el-option label="全部" :value="2"></el-option>
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="未启用" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSearch">查询结果</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 搜索结果列表 -->
        <div class="searchList" v-loading="loading">
            <div class="searchListHead">
                <h2 class="searchListTitle">
                    <i></i>
                    <span>数据列表</span>
                </h2>
                <div class="searchListCtl">
                    <el-button @click="onMember">添加</el-button>
                    <!-- <el-select v-model="searchListCtlForm.arrange" placeholder="排列方式">
                        <el-option label="默认排列方式" value></el-option>
                        <el-option label="按客户名" value="1"></el-option>
                        <el-option label="按业务员" value="2"></el-option>
                    </el-select>-->
                </div>
            </div>
            <div class="searchListContent">
                <el-table
                    ref="searchListTable"
                    :data="searchListTableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    border
                >
                    <el-table-column align='center' type="index" label="序号" width="55"></el-table-column>
                    <el-table-column align='center' prop="userName" label="成员账号" width="180"></el-table-column>
                    <el-table-column align='center' prop="realName" label="姓名" width="180"></el-table-column>
                    <!-- <el-table-column align='center' prop="email" label="邮箱地址"></el-table-column> -->
                    <el-table-column align='center' prop="divisionName" label="所属角色"></el-table-column>
                    <el-table-column align='center' prop="regTime" label="添加时间"></el-table-column>
                    <el-table-column align='center' prop="loginTime" label="最后登录"></el-table-column>
                    <el-table-column align='center' prop="status" label="启用状态" width="140">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status ==0">未启用</span>
                            <span v-if="scope.row.status ==1">启用</span>
                        </template>
                    </el-table-column>
                    <el-table-column align='center' fixed="right" label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="editMember(scope.row)">编辑</el-button>
                            <el-button
                                type="text"
                                size="small"
                                @click="deleteCustomer(scope.row)"
                            >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!--搜索列表分页-->
        <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync='currentPage'
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
        ></el-pagination>
        <!-- 新增弹框 -->
        <el-dialog
            title="添加成员"
            :visible.sync="addFormVisible"
            width="50%"
            :close-on-click-modal="false"
        >
            <div class="addSalesmanContent" v-loading="loading">
                <el-form
                    :inline="false"
                    ref="addForm"
                    :model="addForm"
                    label-width="120px"
                    status-icon
                    class="addForm"
                >
                    <div class="formLeft">
                        <el-form-item label="成员账号" :rules="{required:true}">
                            <el-input v-model="addForm.userName" clearable  :readonly="readonly"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="成员昵称" :rules="{required:true}">
                            <el-input v-model="addForm.nickName" clearable  :readonly="readonly"></el-input>
                        </el-form-item> -->
                        <el-form-item label="成员姓名"  :rules="{required:true}">
                            <el-input v-model="addForm.realName" clearable  :readonly="readonly"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="邮箱地址" :rules="{required:true}">
                            <el-input v-model="addForm.email" clearable   :readonly="readonly"></el-input>
                        </el-form-item> -->
                        <el-form-item label="所属角色" :rules="{required:true}">
                            <el-select v-model="addForm.divisionID" placeholder="全部">
                                <el-option
                                    v-for="item in this.divisionList"
                                    :key="item.divisionID"
                                    :label="item.divisionName"
                                    :value="item.divisionID"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label>
                            <span class="el-upload__tip">选择所属角色后默认继承角色权限，可在成员列表中单独设置权限</span>
                        </el-form-item>
                        <el-form-item label="登录密码" prop="password">
                            <el-input type="password" v-model="addForm.password" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" prop="checkPassword">
                            <el-input
                                type="password"
                                v-model="addForm.checkPassword"
                                autocomplete="off"
                            ></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="备注信息">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 6}"
                                placeholder="请输入内容"
                                v-model="addForm.remark"
                            ></el-input>
                        </el-form-item> -->
                        <el-form-item>
                            <el-button @click="addFormVisible = false">关闭</el-button>
                            <el-button  type="primary" @click="submitForm">提交</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!-- 编辑弹框 -->
        <el-dialog
            title="编辑成员"
            :visible.sync="editFormVisible"
            width="50%"
            :close-on-click-modal="false"
        >
            <div class="addSalesmanContent" v-loading="loading">
                <el-form
                    :inline="false"
                    ref="editForm"
                    :model="editForm"
                    label-width="120px"
                    class="addForm"
                >
                    <div class="formLeft">
                        <el-form-item label="成员账号"  :rules="{required:true}">
                            <el-input v-model="editForm.userName" clearable readonly></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="成员昵称" :rules="{required:true}">
                            <el-input v-model="editForm.nickName" clearable :readonly="readonly"></el-input>
                        </el-form-item> -->
                        <el-form-item label="成员姓名"  :rules="{required:true}">
                            <el-input v-model="editForm.realName" clearable :readonly="readonly"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="邮箱地址" :rules="{required:true}">
                            <el-input v-model="editForm.email" clearable :readonly="readonly"></el-input>
                        </el-form-item> -->
                        <el-form-item label="启用状态">
                            <el-select v-model="editForm.status" placeholder="全部">
                                <el-option label="启用" :value="1"></el-option>
                                <el-option label="未启用" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属角色" prop="divisionID">
                            <el-select v-model="editForm.divisionID" placeholder="全部">
                                <el-option
                                    v-for="item in this.divisionList"
                                    :key="item.divisionID"
                                    :label="item.divisionName"
                                    :value="item.divisionID"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label>
                            <span class="el-upload__tip">选择所属角色后默认继承角色权限，可在成员列表中单独设置权限</span>
                        </el-form-item>
                        <el-form-item label="密码" prop="password">
                            <el-input
                                type="password"
                                v-model="editForm.password"
                                autocomplete="off"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" prop="checkPassword">
                            <el-input
                                type="password"
                                v-model="editForm.checkPassword"
                                autocomplete="off"
                            ></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="备注信息">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 6}"
                                placeholder="请输入内容"
                                v-model="editForm.remark"
                            ></el-input>
                        </el-form-item> -->
                        <el-form-item>
                            <el-button @click="editFormVisible = false">关闭</el-button>
                            <el-button  type="primary" @click="sendEditMember">提交</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            loading: true,
            totalCount: 0,//总数据条数
            couponTotalCount: 0,
            customerSalesmanTotalCount: 0,
            maxResultCount: 10, //默认一页显示的个数,
            currentPage: 1,
            searchForm: {//搜索表单
                Keyword: '',
                status: 2,
            },
            searchListCtlForm: {//排序
                arrange: ''
            },
            searchListTableData: [],
            labelwidth: '90px',//label宽度
            addFormVisible: false,
            editFormVisible: false,
            addForm: {//新增表单
                userName: '',
                nickName: '',
                realName: '',
                email: '',
                divisionID: '',
                password: '',
                checkPassword: '',
                remark: ''
            },
            editForm: {//编辑
                userName: '',
                nickName: '',
                realName: '',
                email: '',
                divisionID: '',
                password: '',
                checkPassword: '',
                remark: ''
            },
            divisionList: [],//角色列表
            readonly: false,
        }
    },
    components: {
        headerNotice
    },
    created() {

    },
    mounted() {
        this.getDatas({
            status: 2,
            MaxResultCount: this.maxResultCount,
        });


    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/Division/GetDivisionMembers",
                params: params,
                success(res) {
                    self.searchListTableData = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //打开增加
        onMember() {
            this.addFormVisible = true;
            //获取角色列表
            this.getDivisionID({
                // MaxResultCount: this.maxResultCount,
                MaxResultCount: 999
            });
        },
        //提交前验证
        submitForm() {
            if (!this.addForm.userName) {
                this.$message.error('请填写成员账号！');
                return;
            }
            // if (!this.addForm.nickName) {
            //     this.$message.error('请填写成员昵称！');
            //     return;
            // }
            if (!this.addForm.realName) {
                this.$message.error('请填写成员姓名！');
                return;
            }
            // if (!this.addForm.email) {
            //     this.$message.error('请填写邮箱地址！');
            //     return;
            // }
            if (!this.addForm.divisionID) {
                this.$message.error('请选择所属角色!');
                return;
            }
            this.addMember();
        },
        //增加
        addMember() {
            let self = this;
            let form = this.addForm;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/Division/AddMember",
                data: form,
                success(res) {
                    self.$message({
                        message: res.data,
                        type: 'success'
                    });
                    //关闭弹框
                    self.addFormVisible = false;
                    //清空表单
                    self.$refs.addForm.resetFields();
                    //从新加载页面数据
                    self.onSearch()
                },
                fail(res) {
                    self.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            })
        },
        //编辑
        editMember(row) {
            let self = this;
            this.editFormVisible = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/Division/GetMemberInfo",
                params: { userId: row.userID },
                success(res) {
                    self.editForm = res;
                    //获取角色列表
                    self.getDivisionID({
                        // MaxResultCount: this.maxResultCount,
                        MaxResultCount: 999,
                    });
                    self.editForm.checkPassword = self.editForm.password
                
                },
                fail(res) {
                    console.log(res);
                    // self.loading = false;
                }
            })
        },
        //提交编辑
        sendEditMember() {
            let self = this;
            if (!this.editForm.userName) {
                this.$message.error('请填写成员账号！');
                return;
            }
            // if (!this.editForm.nickName) {
            //     this.$message.error('请填写成员昵称！');
            //     return;
            // }
            if (!this.editForm.realName) {
                this.$message.error('请填写成员姓名！');
                return;
            }
            // if (!this.editForm.email) {
            //     this.$message.error('请填写邮箱地址！');
            //     return;
            // }
            if (!this.editForm.divisionID) {
                this.$message.error('请选择所属角色!');
                return;
            }
            let form = this.editForm;
            $http.PUT({
                url: this.$store.state.apiUrl + "/api/services/app/Division/UpdateMemberInfo",
                data: form,
                success(res) {
                    self.$message({
                        message: res.data,
                        type: 'success'
                    });
                    //关闭弹框
                    self.editFormVisible = false;
                    //从新加载页面数据
                    self.onSearch()
                },
                fail(res) {
                    self.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            })
        },
        //删除用户
        deleteCustomer(row) {
            this.$confirm('此操作将永久删除该成员, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let self = this;
                $http.DELETE({
                    url: this.$store.state.apiUrl + "/api/services/app/Division/DeleteMember",
                    params: { userID: row.userID },
                    success(res) {
                        console.log(res);
                        self.$message({
                            type: 'success',
                            message: res.data,
                        });
                        self.onSearch()
                    },
                    fail(res) {
                        console.log(res);
                        self.$message({
                            type: 'error',
                            message: res.message,
                        });
                    }
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //搜索
        onSearch(params) {
            let self = this;
            this.searchForm.SkipCount = 0
            this.getDatas(this.searchForm)
            this.currentPage = 1
        },
        //获取所属角色列表
        getDivisionID(params) {
            let self = this;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/Division/GetAll",
                params: params,
                success(res) {
                    self.divisionList = res.items;
                },
                fail(res) {
                }
            })
        },
        //搜索列表一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
                Keyword: this.searchForm.Keyword,
                status: this.searchForm.status
            };
            this.getDatas(params);
        },
        //搜索列表跳转到指定页
        handleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = this.searchForm;
            params.MaxResultCount = this.maxResultCount;
            params.SkipCount = skipCount;
            this.getDatas(params);
        },
    }
}
</script>

<style lang='scss' scoped>
.memberManangementPage {
    //搜索框
    .searchBox {
        margin: 20px 50px;
        border: 1px solid #c5c5c5;
        .searchTitle {
            display: flex;
            align-items: center;
            height: 40px;
            margin-bottom: 10px;
            padding-left: 20px;
            background: #efefef;
            border-bottom: 1px solid #c5c5c5;
            i {
                width: 24px;
                height: 24px;
                background: url("../../assets/imgs/search01.png");
            }
        }
        .searchForm {
            display: flex;
            align-items: center;
            height: 60px;
            padding-left: 20px;
            .el-form-item {
                margin-bottom: 0;
            }
        }
    }
    //搜索列表
    .searchList {
        margin: 20px 50px;
        border: 1px solid #c5c5c5;
        .searchListHead {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 40px;
            padding-left: 20px;
            background: #efefef;
            border-bottom: 1px solid #c5c5c5;
            .searchTitle {
                i {
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/imgs/search02.png");
                }
            }
            .searchListCtl {
                margin-right: 20px;
                button,
                .el-select {
                    width: 130px;
                    margin-left: 10px;
                }
            }
        }
        .searchListContent {
            .detialSpan {
                color: #ff9400;
                cursor: pointer;
            }
        }
    }
    //查看
    .addSalesmanContent {
        margin: 20px 50px;
        // border: 1px solid #c5c5c5;
        display: flex;
        flex-direction: column;
        align-items: center;
        .editTitle {
            height: 40px;
            line-height: 40px;
            align-self: normal;
            margin-bottom: 10px;
            padding-left: 20px;
            // border-bottom: 1px solid #c5c5c5;
        }
        .addForm {
            display: flex;
            .formLeft {
                margin-right: 20px;
            }
            .formRight {
                margin-left: 20px;
                img {
                    width: 220px;
                }
            }
        }
    }
}
</style>
<style lang="scss">
.memberManangementPage {
    .el-dialog__header {
        background: #efefef;
        border-bottom: 1px solid #c5c5c5;
    }
    .addSalesmanContent {
        .addForm {
            .formLeft {
                .el-select {
                    width: 100%;
                }
            }
        }
    }
}
</style>